import script from "./HdIntentionInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./HdIntentionInfo.vue?vue&type=script&setup=true&lang=js"

import "./HdIntentionInfo.vue?vue&type=style&index=0&id=1d2aad0d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2aad0d"]])

export default __exports__